/* eslint-disable import/prefer-default-export */
import { APP_INITIALIZATION } from "./const";

export const appInitAction = (): {
  type: string;
} => {
  return {
    type: APP_INITIALIZATION,
  };
};
